export class User {
    userDisplayName: string;
    urlId: string;
}
